export const WEEK_FORMAT = 'GGGG-[w]WW';
